module.exports = __webpack_public_path__ + "img/img-thumbnail-01.90b3cf99.png";